export class GeneralEntity {
  id?: number | string;
}
